var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssessIcon = function SvgAssessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.85 17.743a3.789 3.789 0 0 0-.594-4.628 3.857 3.857 0 0 0-5.425 0 3.789 3.789 0 0 0 0 5.386 3.859 3.859 0 0 0 4.936.412l1.869 1.855c.312.31.818.31 1.13 0a.79.79 0 0 0 0-1.122l-1.917-1.903Zm-1.767-3.464c.85.845.85 2.214 0 3.059a2.19 2.19 0 0 1-3.082 0 2.152 2.152 0 0 1 0-3.06 2.19 2.19 0 0 1 3.082 0Z",
    fill: "#797CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.997 3a1 1 0 0 0-1 1v12.147a1 1 0 0 0 1 1h6.668a5 5 0 0 1 6.494-6.071V4a1 1 0 0 0-1-1H3.997Zm1 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-6Z",
    fill: "#797CDB"
  })));
};
export default SvgAssessIcon;